var bpLogin = {}
var table_list = {}
var common = {}
var faq = {}
var modal = {}
var current_scrollY =0;

common = {
	pageTop: function(){
		var pageTop = $('.pagetop');
		pageTop.hide();
		pageTop.css('opacity', 1);
		pageTop.css({
			opacity: 1,
			right: (($(window).width()-1080)/2)-75
		});
		$(window).scroll(function () {
		    if ($(this).scrollTop() > 200) {
		        pageTop.fadeIn();
		    } else {
		        pageTop.fadeOut();
		    }
		});
	    pageTop.click(function () {
	        $('body, html').animate({scrollTop:0}, 500, 'swing');
	        return false;
	    });
	},
	pageTopResize: function pageTopResize(){
		$(window).on('resize', function(event) {
			var pageTop = $('.pagetop');
			pageTop.css('right', (($(window).width()-1080)/2)-75);
		});
	},
	pageTopSet: function pageTopSet(){
		$('a[href^="#"]').SmoothScroll({
		    duration : 250,    // スピード
		    easing : 'swing' // 動き方
		});
	}
},
modal = {
	initModal: function initModal(){
		modal.filterResize();
		$('.modal-open').on('click', function(event) {
			modal.fixedWindow();
			modal.show();
		});
		$('.scope').on('click', function(event) {
			modal.fixedWindow();
			modal.show();
		});
		$('.modal-close').on('click', function(event) {
			modal.fixedWindowRecover();
			modal.hide();
		});
		$('.filter-modal').on('click', function(event) {
			modal.fixedWindowRecover();
			modal.hide();
		});
		$('.close-btn').on('click', function(event) {
			modal.fixedWindowRecover();
			modal.hide();
		});
	},
	filterResize: function filterResize(){
		$('.filter-modal').css({
			width: $(window).innerWidth(),
			height: $(window).innerHeight()
		});
	},
	fixedWindow: function fixedWindow(){
		  current_scrollY = $( window ).scrollTop(); 
		  $( 'html' ).css( {
		    position: 'fixed',
		    width: '100%',
		    top: -1 * current_scrollY
		  } );
	},
	fixedWindowRecover: function fixedWindowRecover(){
		$( 'html' ).attr( { style: '' } );
		$( 'html, body' ).prop( { scrollTop: current_scrollY } );
	},
	show: function showModal() {
		bpLogin.centering();
		modal.filterResize();
		$('.filter-modal').fadeIn();
		$('.modal').fadeIn();
	},
	hide: function hideModal() {
		$('.filter-modal').fadeOut();
		$('.modal').fadeOut();
	}
},
bpLogin = {
	//login画面導入シーンのアニメーションクラス付与
	opening: function(){
		$('.sepalate-logo').addClass('ready');
		setTimeout(function(){
			$('.page-login').addClass('ready');
		},1000);
	},
	vCentering: function() {
		var c_target = $('.vCentering');
		var h = c_target.height();
		var wh = $(window).height();

		c_target.css('top', (wh-h)/2 - 50);
	},
	hCentering: function() {
		var c_target = $('.hCentering');
		var w = c_target.width();
		var ww = $(window).width();

		c_target.css('left', (ww-w)/2);
	},
	centering: function() {
		var c_target = $('.centering');
		var h = c_target.innerHeight();
		var w = c_target.innerWidth();
		var wh = $(window).innerHeight();
		var ww = $(window).innerWidth();

		var topDistance = ((wh-h)/2) + current_scrollY;
		if( topDistance < 40){
			c_target.css({
				top: 40,
				left: (ww-w)/2
			});
		} else {
			c_target.css({
				top: topDistance,
				left: (ww-w)/2
			});
		}
	},
	centeringAfterOpacity: function(){
		$('.centering').css('opacity', 1);
	}
}

table_list = {
	clickAccordion : function() {
		$('.table-list').find('.accordion').on('click',function(event) {
			if($(this).parents('.table-list').hasClass('active')){
				$(this).parents('.table-list').removeClass('active');	
			} else {
				$(this).parents('.table-list').addClass('active');	
			}
		});
	},
	buttonLinkNotBubling : function(){
		$('.list-tools').find('a').on('click', function(event) {
			event.stopImmediatePropagation()
			/* Act on the event */
		});
	},
	lineHeightFix : function lineHeightFix(){
		$('.list-contents').each(function(index, el) {
			var compare = [];
			var thisGroup = $(this);
			var thisGroupChild = $(this).children('div');
			thisGroupChild.each(function(index, el) {
				compare.push($(this).outerHeight());
				if(thisGroupChild.index($(this))== thisGroupChild.length -1){
					var maxHeight = Math.max.apply(null, compare);
					console.log(maxHeight);
					$(this).parent().children('div').css('height', maxHeight);

				}
			});
		});
	}


}

faq = {
	//FAQページのQA情報を参照してQA目次を生成

	generateOutline : function(){
		$(".qa-list").find('li').each(function(index, el) {
			var num = $(".qa-list").find('li').index($(this)) +1;
			$(this).attr('id', "qa"+num);
			var id = $(this).attr('id');
			var txt = $(this).find('.title').text();
			var outlineTargetList = $('.question-link-list');
			var insertContents = "<li><a href='#"+id+"'>"+txt+"</a></li>"
			outlineTargetList.append(insertContents);
		});
	}
}



$(function(){

	bpLogin.vCentering();
	bpLogin.hCentering();
	bpLogin.centering();
	faq.generateOutline();

	$(window).on('load', function(event) {
		bpLogin.centeringAfterOpacity();
		setTimeout(function(){
			bpLogin.opening();
		},500);

		table_list.clickAccordion();
		table_list.buttonLinkNotBubling();
		// table_list.lineHeightFix();
		common.pageTop();
		common.pageTopResize();
		common.pageTopSet();
		modal.initModal();

	});

	$(window).on('resize', function(event) {
		bpLogin.hCentering();
		bpLogin.centering();
		modal.filterResize();
	});
	
});